import { CTATypes } from '../../new-lib/constants/common';
import { EntityOffer } from '../../new-lib/types/entity';
import WhatsappBuilder from './whatsapp-builder';

class WhatsappCityScapeOffers extends WhatsappBuilder {
  constructor(
    entity: object,
    path: string,
    referer: string,
    userId: string,
    eventId: string,
    entityType: CTATypes,
    offer?: EntityOffer
  ) {
    super(entity, path, referer, userId, eventId, entityType);
  }

  buildMessage = (): void => {
    let message = '';
    if (this.language === 'ar') {
      message = `أرغب في المزيد من المعلومات ${
        this.name ? `عن عروض ${this.name}` : ''
      }%0A`;
      message += `رقم مرجعى ${this.userData} %0A%0A`;
      message += `*برجاء عدم حذف الرقم المرجعي* ليتمكن  أحد مستشاري العقارات لدينا بمساعدك.`;
    } else {
      message = `I would like more information ${
        this.name ? `on ${this.name}'s offers` : ''
      }.%0A`;
      message += `Reference ${this.userData} %0A%0A`;
      message += `*Please do NOT delete this message* as our property consultants use this reference number to better assist you.`;
    }

    const messageEncoded = message.replace(/&/g, '%26').replace(/#/g, '%23');
    window.open(
      `https://wa.me/2${this.WHATSAPP_NUMBER}?text=${messageEncoded}
      `,
      '_blank'
    );
  };
}

export default WhatsappCityScapeOffers;
